import { WhitelabelType } from '@/Enums/Whitelabels/WhitelabelType.enum';
import type { IControlOption } from '@/Interfaces/ControlOption.interface';
import type { IParsedWhitelabel } from '@/Interfaces/Whitelabels/Whitelabel.interface';
import { LogoWhitelabelCell } from '@/components/Grid/LogoCell';
import { defaultQuickFilter } from '@/helpers/grid/quickFilter';
import { dateToShortFormat } from '@/helpers/valueFormatter/dateFormatter.helpers';
import {
  type GridCellParams,
  type GridColDef,
  type GridFilterItem,
  type GridFilterOperator,
  type GridRenderCellParams,
  getGridStringQuickFilterFn,
} from '@mui/x-data-grid-pro';
import ViewButton from './ViewButton';
import WhitelabelTypeChip from './WhitelabelTypeChip';

const orgFilterOperator: GridFilterOperator = {
  label: WhitelabelType.Organization,
  value: 'orgFilter',
  getApplyFilterFn: (filterItem: GridFilterItem) => {
    if (!filterItem.field || !filterItem.value || !filterItem.operator) {
      return null;
    }

    return (params: GridCellParams<IParsedWhitelabel, IControlOption>): boolean => {
      return filterItem.value.length ? filterItem.value.includes(params.value?.value) : true;
    };
  },
};

const orgSortComparator = (v1: IControlOption, v2: IControlOption) => v1?.label.localeCompare(v2?.label ?? '');

export const getColumns = (onViewClick: (row: IParsedWhitelabel) => void) => {
  return (
    [
      {
        field: 'name',
        headerName: 'Whitelabel Name',
        getApplyQuickFilterFn: getGridStringQuickFilterFn,
        flex: 3.5,
      },
      {
        field: 'mainLogo',
        headerName: 'Logo',
        sortable: false,
        flex: 1.5,
        display: 'flex',
        renderCell: LogoWhitelabelCell,
      },
      {
        field: 'organization',
        headerName: 'Organization',
        valueFormatter: (value: IControlOption) => value?.label,
        filterOperators: [orgFilterOperator],
        sortComparator: orgSortComparator,
        flex: 2,
      },
      {
        field: 'parentId',
        headerName: 'Org / Whitelabel',
        align: 'center',
        headerAlign: 'center',
        display: 'flex',
        renderCell: WhitelabelTypeChip,
        flex: 2,
      },
      {
        field: 'createdAt',
        headerName: 'Date Created',
        align: 'center',
        headerAlign: 'center',
        valueFormatter: (value: string) => dateToShortFormat(value, 'N/A'),
        flex: 2,
      },
      {
        field: 'id',
        headerName: 'Action',
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        display: 'flex',
        renderCell: (params: GridRenderCellParams) => <ViewButton {...params} onClick={onViewClick} />,
        flex: 1.2,
      },
    ] as GridColDef[]
  ).map(item => ({
    ...item,
    flex: item.flex ?? 1,
    getApplyQuickFilterFn: item.getApplyQuickFilterFn || defaultQuickFilter,
  }));
};
